import React, { Component } from "react";
import AsideDropDown from "./asideDropdown";
import AccordionBillingMenu from "./billingPlatformDropdown";
import SideLink from "./sidelink";

import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  bookingRequestIndentLinkName, bookingRequestOrdersLinkNameAndShipment,
  consigneeConsignorCheck, dashboardLinkCustomer,
  enablePOInBills,
  FEATURES,
  LOCAL_STORAGE, myProfileHideCustomer,
  noLogoCustomerInSidebar, sideBarOptionsHide
} from '../../utils/constant';

class AsideBar extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      tempbillingpartbranchIds: [],
      tempbillingpartIds: [],
      tempbranchIds: [],
      error: false,
      logoURL: null
    };
  }
  componentDidMount() {
    var billingpartbranchIds = localStorage.getItem("billingpartbranchIds");
    var billingpartIds = localStorage.getItem("billingpartIds");
    var branchIds = localStorage.getItem("branchIds");
    this.setState({
      tempbillingpartbranchIds:
        billingpartbranchIds != "" && billingpartbranchIds != undefined
          ? billingpartbranchIds.split(",")
          : [],
      tempbillingpartIds:
        billingpartIds != "" && billingpartIds != undefined
          ? billingpartIds.split(",")
          : [],
      tempbranchIds:
        branchIds != "" && branchIds != undefined ? branchIds.split(",") : [],
    });
  }

  redirectToFlutterUrl = (type)=> {
    switch (type.toUpperCase()){
      case "INVOICE" : 
      let invoice_url = `${process.env.REACT_APP_FLUTTER_URL_TA}/?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}#InvoiceScreen`;
      window.open(invoice_url, "_blank");
    }
  }

  render() {
    const imgURL = `${process.env.REACT_APP_BASE_COMMON}/profile_images/${LOCAL_STORAGE.customerLogo}`
    let imageSrc
    let imgIconWidth = "60%";
    let imgIcon = `assets/img/${LOCAL_STORAGE.customerNo}.png`
    switch (LOCAL_STORAGE.customerNo) {
      case 212:
        imageSrc = "assets/svg/technova.svg";
        imgIconWidth = "50%";
        break;
      case 984:
        imageSrc =
          "https://www.poultryindia.co.in/poultry-biz/media/logo_allana1.png";
        imgIconWidth = "60%";
        break;
      case 549:
        imgIconWidth = "90%";
        break;
      case 1122:
        imageSrc =
          "https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/UPL_official_logo.svg/1200px-UPL_official_logo.svg.png";
        imgIconWidth = "60%";
        break;
      case 1330:
        imageSrc = "assets/img/lntGIF.gif";
        imgIconWidth = "100%";
        break;
      case 1278:
        imgIconWidth = "80%";
        break;
      case 1279:
        imgIconWidth = "80%";
        break;
      case 1358:
        imgIconWidth = "80%";
        break;
      case 1375:
        imgIconWidth = "80%";
        break;
      case 1423:
        imgIconWidth = "100%";
        break;
      case 1562:
      case 1568:
        imageSrc = `${process.env.REACT_APP_BASE_COMMON}/profile_images/${LOCAL_STORAGE.customerLogo}`
        imgIconWidth = "100%";
        break;
      case 1654:
          imgIcon = `assets/img/${LOCAL_STORAGE.customerNo}.jpeg`
          imgIconWidth = "100%";
          break;
      default:
        imageSrc = "assets/img/logo.png";
        imgIconWidth = "60%";
        break;
    }
    const { t } = this.props;
    return (
      <React.Fragment>
        <div id="sidebars">
          <aside id="asidebar" className="sidenav smallSiderbar">
            <div
              className={noLogoCustomerInSidebar ? "pt-2 pb-2 b-white" : "img-thumbnail"}>
              {!this.state.error && <img
                src={(LOCAL_STORAGE?.customerLogo == 'null' || LOCAL_STORAGE?.customerLogo == 'undefined' || LOCAL_STORAGE?.customerLogo == undefined ) ? imgIcon : imgURL}
                className={noLogoCustomerInSidebar ? "pt-1 pb-1" : "sidelogo pt-1"}
                alt="logo"
                style={{
                  objectFit: "contain",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: imgIconWidth,
                }}
                onError={() => { this.setState({ error: true }) }}
              />}
              {this.state.error && <img
                src={imageSrc}
                className={noLogoCustomerInSidebar ? "pt-1 pb-1" : "sidelogo pt-1"}
                alt="logo"
                style={{
                  objectFit: "contain",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: imgIconWidth,
                }}
              />}
            </div>
            {this.props.permissions && this.props.role.role != "Vendor" ? (
              <>
                {this.props.permissions.TA_DASHBOARD &&
                  this.props.permissions.TA_DASHBOARD.VIEW == true &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  <>
                    {dashboardLinkCustomer ? (
                      <SideLink
                        Exact={true}
                        imgLink="assets/svg/dashboard.svg"
                        linkTo="/dashboard"
                        linkName={t("Dashboard")}
                      />
                    ) :
                      <SideLink
                        Exact={true}
                        imgLink="assets/svg/dashboard.svg"
                        linkTo="/"
                        linkName={t("Dashboard")}
                      />
                    }
                  </>
                ) : (
                  ""
                )}

                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true &&
                  !sideBarOptionsHide &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  <SideLink
                    imgLink="assets/img/planningLogo.svg"
                    linkTo="/planning"
                    linkName={t("Planning")}
                  />
                ) : null}


                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true &&
                  !sideBarOptionsHide &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  <SideLink
                    imgLink="assets/svg/bookingsLogo.svg"
                    linkTo="/booking-request"
                    linkName={bookingRequestIndentLinkName ? t("Indents") : bookingRequestOrdersLinkNameAndShipment ? t("orders") : t("Bookings")}
                  />
                ) : null}

                {/* {this.props.permissions.TA_SHIPMENT &&
                this.props.permissions.TA_SHIPMENT.VIEW == true &&
                this.props.role.role != "Vendor" ?
               
                : null} */}

                {/* <CreateSideMenu
                menu="Planning"
                src="assets/svg/bookingsLogo.svg"
                type="planning"
                linkArray={[
                  { subLinkName: 'Planning', locationTo: '/planning' }
                ]}
              />

              {
                process.env.NODE_ENV != "live" ?
                  <CreateSideMenu
                    menu="Bookings"
                    src="assets/svg/bookingsLogo.svg"
                    type="bookings"
                    linkArray={[
                      { subLinkName: 'Bookings', locationTo: '/booking-request' }
                    ]}
                  />
                  :
                  null
              } */}

                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  <SideLink
                    imgLink="assets/svg/Orders.svg"
                    linkTo="/shipment"
                    linkName={bookingRequestOrdersLinkNameAndShipment ? t("Bookings") : t("orders")}
                  />
                ) : null}

                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true ? (
                  <SideLink
                    imgLink="assets/img/deliveryLogo.svg"
                    linkTo="/deliveries"
                    linkName={t("deliveries")}
                  />
                ) : null}

                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true &&
                  !consigneeConsignorCheck(this.props.role.role) &&
                  !sideBarOptionsHide ? (
                  <SideLink
                    imgLink="assets/img/invoiceLogo.svg"
                    linkTo={FEATURES.redirectToFlutterOnInvoice ? "" : "/invoice"}
                    linkName={t("Invoice")}
                    onClick={()=> FEATURES.redirectToFlutterOnInvoice && this.redirectToFlutterUrl("invoice")}
                  />
                ) : null}

                <SideLink
                    imgLink="assets/img/invoiceLogo.svg"
                    linkTo="/ewaybill"
                    linkName={t("eway_bill")}
                  />

                {this.props.permissions.TA_SHIPMENT &&
                  this.props.permissions.TA_SHIPMENT.VIEW == true &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  < SideLink
                    imgLink="assets/svg/hire_memo.svg"
                    linkTo="/hirememo"
                    linkName={"Hire Memo"}
                  />
                ) : null}

                {!sideBarOptionsHide &&
                  !consigneeConsignorCheck(this.props.role.role) ? (
                  <>
                    <SideLink
                      imgLink="assets/svg/Orders.svg"
                      linkTo="/vehicleavailability"
                      linkName={t("vehicle_availability")}
                    />
                  </>
                ) : null}
                {/* <SideLink
                imgLink="assets/svg/Orders.svg"
                linkTo="/orders"
                linkName={t("orders")}
              />  */}
                <div>
                  <SideLink
                    imgLink="assets/svg/download-file.svg"
                    linkTo="/ExportDownload"
                    linkName={"Download"}
                  />
                  {/* <div className="right-arrow">
                    <div class="arrow white"></div>
                    <div class="arrow"></div>
                    <div class="arrow"></div>
                  </div> */}
                </div>
              </>
            ) : (
              <>
                {this.props.role.role != "Vendor" ? (
                  <>
                    <SideLink
                      Exact={true}
                      imgLink="assets/svg/dashboard.svg"
                      linkTo="/"
                      linkName={t("dashboard")}
                    />
                    <SideLink
                      imgLink="assets/svg/Orders.svg"
                      linkTo="/shipment"
                      linkName={t("orders")}
                    />
                    <SideLink
                      imgLink="assets/svg/Orders.svg"
                      linkTo="/deliveries"
                      linkName={t("deliveries")}
                    />
                    {!sideBarOptionsHide ? (
                      <>
                        <SideLink
                          imgLink="assets/svg/Orders.svg"
                          linkTo="/vehicleavailability"
                          linkName={t("vehicle_availability")}
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </>
            )}
            {this.props.role.role == "Vendor" ? (
              <>
                {myProfileHideCustomer ?
                  null
                  :
                  <SideLink
                    imgLink="assets/svg/Orders.svg"
                    linkTo="/my-profile"
                    linkName={t("my_profile")}
                  />
                }

                {!sideBarOptionsHide ?
                  < SideLink
                    imgLink="assets/svg/Orders.svg"
                    linkTo="/active-orders"
                    linkName={t("active_orders")}
                  />
                  : null}
                <SideLink
                  imgLink="assets/svg/Orders.svg"
                  linkTo="/alloted-orders"
                  linkName={t("alloted_orders")}
                />
                <SideLink
                  imgLink="assets/svg/Orders.svg"
                  linkTo="/vehicle-reporting"
                  linkName={t("vehicle_reporting")}
                />
                {!sideBarOptionsHide ? (
                  <SideLink
                    imgLink="assets/svg/Orders.svg"
                    linkTo="/add-vehicle"
                    linkName={t("vehicle_availability")}
                  />
                ) : null}
                {!sideBarOptionsHide ? (
                  <SideLink
                    imgLink="assets/svg/Orders.svg"
                    onClick={() => {
                      const dt = `${process.env.REACT_APP_DT}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}`;
                      window.open(dt, "_blank");
                    }}
                    linkName={t("track_trips")}
                  />
                ) : null}

                {!sideBarOptionsHide ? (
                 <AccordionBillingMenu /> 
                ) :  ''}

                {bookingRequestIndentLinkName ? (
                  <SideLink
                    imgLink="assets/svg/Billing Platform.svg"
                    linkTo="/tutorial"
                    linkName={t("tutorial")}
                  />
                ) : null}

                <SideLink
                  imgLink="assets/svg/download-file.svg"
                  linkTo="/ExportDownload"
                  linkName={"Download"}
                />
                
              </>
            ) : null}

            {/* {this.props?.permissions?.TA_OVERALL_MASTER?.VIEW == true ? (
              <></>
            ) : null} */}
            {!consigneeConsignorCheck(this.props.role.role) ? <AsideDropDown /> : null}
          </aside>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions, auth }) => {
  return {
    permissions,
    auth,
  };
};
export default connect(mapStateToProps)(translate("sidebar")(AsideBar));
